import { render } from "./SingleGameList.vue?vue&type=template&id=71e7bc22&scoped=true"
import script from "./SingleGameList.vue?vue&type=script&lang=js"
export * from "./SingleGameList.vue?vue&type=script&lang=js"

import "./SingleGameList.vue?vue&type=style&index=0&id=71e7bc22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e7bc22"]])

export default __exports__